module.exports = __webpack_public_path__ + "media/luxury-2026/estate-pool-b10dd6ee.jpg";